export const ADVANCED_SEARCHES_TAG_TYPE = 'AdvancedSearches' as const;
export const ALL_ADVANCED_SEARCHES_ID = 'ALL' as const;

/**
 * Tag id for a search's results (execute, paged execute, map, heatmap and
 * metrics). Kept apart from the search's own id so a rename, folder move or
 * delete refreshes the search and the list without re-running its results.
 * Scout's search tools invalidate the whole tag type, results included.
 */
export const searchResultsTagId = (id: number | string) => `results-${id}` as const;
